<template lang="pug">
v-menu(rounded="lg" offset-y left :close-on-content-click="false" min-width=300 max-height=320)
  template(v-slot:activator="{ on: menu, attrs }")
    v-tooltip(v-if="showTooltip" top color="black")
      template(v-slot:activator="{ on: tooltip }")
        v-btn(v-bind="attrs" v-on="{ ...menu, ...tooltip }" icon color="neutral500" :disabled="disabled")
          v-icon(:size="iconSize") $yzi-settings-02
      .text-xs.white--text {{ $t('customize_column') }}
    v-btn(v-else icon v-on="{ ...menu }" color="neutral500" :disabled="disabled")
      v-icon(:size="iconSize") $yzi-settings-02
  
  v-list(flat)
    slot(name="prepend-list")
    v-list-item.px-6
      .text-md.font-semibold {{ $t('customize_column') }}
    v-list-item.px-6(v-if="showNameRow")
      v-list-item-action.mr-2
        y-checkbox(input-value="true" disabled)
      v-list-item-content
        .d-flex.align-center
          .text-sm.neutral700--text Name
          v-spacer
          .text-xs.neutral500--text System

    v-list-item-group
      v-list-item.px-6(v-for="option in options" :key="options.name")
        v-list-item-action.mr-2
          y-checkbox(v-model="option.enable" @onChecked="onChecked")
        v-list-item-content(@click.prevent="toggle(option)")
          .d-flex.align-center
            .text-sm.neutral700--text {{ option.field_name | fieldNameDisplay }}
            v-spacer
            .text-xs.capitalize.neutral500--text {{ option.type ? option.type : 'custom' }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: null
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      fields: 'customers/getAllFields',
      donorFields: 'donation/getAllFields',
      clinicFields: 'clinic/getPatientFields',
      appointmentFields: 'clinic/getAppointmentFields',
      reviewInvitationFields: 'clinic/getReviewInvitationFields',
      registrationFields: 'clinic/getRegistrationFields',
      reservationFields: 'clinic/getReservationFields',
      preorderFields: 'clinic/getPreorderFields',
      inventoryFields: 'clinic/getInventoryFields',
      serviceFields: 'clinic/getServiceFields',
      packageFields: 'clinic/getPackageFields',
      stocktakeFields: 'clinic/getStocktakeFields',
      locationFields: 'clinic/getLocationFields',
      userFields: 'clinic/getUserFields',
      billingFields: 'clinic/getBillingFields',
      inventoryInvoiceFields: 'clinic/getInventoryInvoiceFields',
      doctorVisitFields: 'clinic/getDoctorVisitFields',
      nonDoctorVisitFields: 'clinic/getNonDoctorVisitFields',
      allPrescriptionReportFields: 'clinic/getAllPrescriptionReportFields',
      dispenseDetailReportFields: 'clinic/getDispenseDetailReportFields',
      transactionSalesReportFields: 'clinic/getTransactionSalesReportFields',
      billingDetailSalesReportFields: 'clinic/getBillingDetailSalesReportFields',
      dailySalesReportFields: 'clinic/getDailySalesReportFields',
      salesByPanelReportFields: 'clinic/getSalesByPanelReportFields',
      allPanelReportFields: 'clinic/getAllPanelReportFields',
      allPanelInvoiceReportFields: 'clinic/getAllPanelInvoiceReportFields',
      allPanelInvoiceFields: 'clinic/getAllPanelInvoiceFields',
      purchaseHubQuotationFields: 'clinic/getPurchaseHubQuotationFields',
      purchaseHubOrderFields: 'clinic/getPurchaseHubOrderFields',
      purchaseHubInvoiceFields: 'clinic/getPurchaseHubInvoiceFields',
      allInventoryListFields: 'clinic/getInventoryListFields',
      offerFields: 'clinic/getOfferFields',
      loyaltyFields: 'clinic/getLoyaltyFields',
      panelClaimInvoiceFields: 'clinic/getPanelClaimInvoiceFields',
      panelClaimFields: 'clinic/getPanelClaimFields',
      hqVisitFields: 'hq/getVisitFields',
      hqBillingFields: 'hq/getBillingFields',
      hqAppointmentFields: 'hq/getAppointmentFields',
      hqAppointmentScheduleFields: 'hq/getAppointmentScheduleFields',
      hqInventoryFields: 'hq/getInventoryFields',
      hqServicesFields: 'hq/getServicesFields',
      hqPackagesFields: 'hq/getPackagesFields',
      hqInventoryListFields: 'hq/getInventoryListFields',
      hqStocktakeFields: 'hq/getStocktakeFields',
      hqStorageLocationFields: 'hq/getStorageLocationFields'
    }),
    showNameRow() {
      return this.type !== 'panel_claim_invoice' && this.type !== 'panel_claim'
    },
    options () {
      switch (this.type) {
        case 'donor':
          return this.donorFields
        case 'patient':
          return this.clinicFields
        case 'appointment':
          return this.appointmentFields
        case 'review_invitation':
          return this.reviewInvitationFields
        case 'registration':
          return this.registrationFields
        case 'reservation':
          return this.reservationFields
        case 'preorder':
          return this.preorderFields
        case 'inventory':
          return this.inventoryFields
        case 'service':
          return this.serviceFields
        case 'package':
          return this.packageFields
        case 'stocktake':
          return this.stocktakeFields
        case 'location':
          return this.locationFields
        case 'user':
          return this.userFields
        case 'billing':
          return this.billingFields
        case 'inventory_invoice':
          return this.inventoryInvoiceFields
        case 'doctor_visit':
          return this.doctorVisitFields
        case 'non_doctor_visit':
          return this.nonDoctorVisitFields
        case 'all_prescription_report':
          return this.allPrescriptionReportFields
        case 'dispense_detail_report':
          return this.dispenseDetailReportFields
        case 'transaction_sales_report':
          return this.transactionSalesReportFields
        case 'billing_detail_sales_report':
          return this.billingDetailSalesReportFields
        case 'daily_sales_report':
          return this.dailySalesReportFields
        case 'sales_by_panel_report':
          return this.salesByPanelReportFields
        case 'all_panel_report':
          return this.allPanelReportFields
        case 'all_panel_invoice_report':
          return this.allPanelInvoiceReportFields
        case 'all_panel_invoice':
          return this.allPanelInvoiceFields
        case 'purchase_hub_quotation':
          return this.purchaseHubQuotationFields
        case 'purchase_hub_order':
          return this.purchaseHubOrderFields
        case 'purchase_hub_invoice':
          return this.purchaseHubInvoiceFields
        case 'all_inventory_list':
          return this.allInventoryListFields
        case 'offer':
          return this.offerFields
        case 'loyalty':
          return this.loyaltyFields
        case 'panel_claim_invoice':
          return this.panelClaimInvoiceFields
        case 'panel_claim':
          return this.panelClaimFields
        case 'hq_visit':
          return this.hqVisitFields
        case 'hq_billing':
          return this.hqBillingFields
        case 'hq_appointment':
          return this.hqAppointmentFields
        case 'hq_appointment_schedule':
          return this.hqAppointmentScheduleFields
        case 'hq_inventory':
          return this.hqInventoryFields
        case 'hq_services':
          return this.hqServicesFields
        case 'hq_packages':
          return this.hqPackagesFields
        case 'hq_inventory_list':
          return this.hqInventoryListFields
        case 'hq_stocktake':
          return this.hqStocktakeFields
        case 'hq_storage_location':
          return this.hqStorageLocationFields
        default:
          return this.fields
      }
    }
  },
  methods: {
    toggle (option) {
      option.enable = !option.enable
      this.saveSelectedField()
    },
    onChecked () {
      this.saveSelectedField()
    },
    saveSelectedField () {
      const ids = this.options.filter(option => option.enable).map(item => item.id)
      if (ids) {
        const key = !this.type ? 'yz_customer_fields' : `yz_${this.type}_fields`
        localStorage.setItem(key, JSON.stringify(ids))
      }
    }
  }
}
</script>